export default __webpack_public_path__ + "static/media/e-bunifikasi-logotype-l.f46935e9.svg";